import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FnUiCheckboxComponent } from './fn-ui-checkbox.component';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatCheckboxModule,
    MatCheckboxModule,
  ],
  declarations: [
    FnUiCheckboxComponent
  ],
  exports: [
    FnUiCheckboxComponent
  ]
})
export class FnUiCheckboxModule { }
